import { onReady } from '../utils/dom';
import { initBackToTop } from './backToTop';
import { initCartIconBridge } from './cartIconBridge';
import { initIubenda } from './iubenda';
import { initInterfaceEnhancements } from './interfaceEnhancements';

export function initRuntime(): void {
  initIubenda();
  initInterfaceEnhancements();

  onReady(() => {
    initBackToTop();
    initCartIconBridge();
  });
}
